//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

export const SHORTLINK_MODAL_MESSAGE_REVENUE =
  'Shorten your shoppable links to get revenue data for this post.';

export const SHORTLINK_MODAL_MESSAGE_DEFAULT =
  "Add your link into the field below, and we'll generate a short link for you.";
